var _rect;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgCheckbox = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 9,
  height: 9,
  viewBox: "0 0 9 9",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
  x: 0.25,
  y: 0.25,
  width: 8.5,
  height: 8.5,
  rx: 1.75,
  fill: "#EDF0F9",
  stroke: "#9FADBE",
  strokeWidth: 0.5
})));
const ForwardRef = /*#__PURE__*/forwardRef(SvgCheckbox);
export { ForwardRef as ReactComponent };